// Error messages
export const errorMessage = "This field is required";
export const errorMessageEmail = `Please enter a valid email. for example("abc@gmail.com")`;

// form fields validation patterns
export const patternEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
